export default __webpack_public_path__ + "f8ee8dc36e85df2b44045ea0cf6466df.svg";